export function getMessage(err: string): JSX.Element {
    switch (err) {
        case "alreadyClickedThis": {
            return (
                <div className="flex m-auto justify-center">
                    <span className="text-yellow-500 ri-error-warning-fill"></span>
                    <span className="ml-2">Klikkasit jo tätä korttia.</span>
                </div>
            );
        }
        case "alreadyTwoFlipped": {
            return (
                <div className="flex m-auto justify-center">
                    <span className="ri-arrow-up-down-fill font-bold"></span>
                    <span className="mx-2">Käännä kortit takaisin ennen kuin jatkat.</span>
                    <span className="ri-arrow-up-down-fill font-bold"></span>
                </div>
            );
        }
        case "rightSideFirst": {
            let message = (
                <div className="flex m-auto justify-center">
                    <span className={"ri-arrow-right-fill font-bold text-green-500"}></span>
                    <span className="mx-2">Valitse kortti ensin oikealta puolelta.</span>
                    <span className={"ri-arrow-right-fill font-bold text-green-500"}></span>
                </div>
            );
            return message;
        }
        case "sameSide": {
            let message = (
                <div className="flex m-auto justify-center">
                    <span className={"ri-arrow-left-fill font-bold text-yellow-500"}></span>
                    <span className="mx-2">Valitse kortti toiselta puolelta.</span>
                    <span className={"ri-arrow-left-fill font-bold text-yellow-500"}></span>
                </div>
            );
            return message;
        }
        default: {
            return <div>Something went wrong.</div>
        }
    }
}

export function getCardColors(fileExt: string) {
    switch (fileExt) {
        case 'png':
        case 'jpeg':
        case 'jpg':
            return "border-yellow-500 bg-yellow-500";
        case 'webm':
        case 'mp4':
            return "border-green-500 bg-green-500";
        default:
            return "border-teal-500 bg-teal-500";
    }
}

export function getCardSize(level: number): string {
    switch (level) {
        case 4: {
            return " w-110px md:w-175px lg:w-225px xl:w-250px 2xl:w-300px 3xl:w-350px 4xl:w-390px 5xl:w-400px 6xl:w-450px 7xl:w-550px 8xl:w-600px 9xl:w-650px 10xl:w-700px";
        }
        case 6: {
            return " w-100px md:w-120px lg:w-190px xl:w-190px 2xl:w-225px 3xl:w-240px 4xl:w-275px 5xl:w-290px 6xl:w-330px 7xl:w-400px 8xl:w-440px 9xl:w-475px 10xl:w-500px 11xl:w-600px";
        }
        case 12: {
            return " w-100px md:w-100px lg:w-135px xl:w-140px 2xl:w-175px 3xl:w-175px 4xl:w-200px 5xl:w-210px 6xl:w-250px 7xl:w-290px 8xl:w-325px 9xl:w-350px 10xl:w-370px 11xl:w-450px";
        }
        default: {
            return "w-100px";
        }
    }
}